<template>
  <div id="app">
    <!-- <home-mobile v-if="isMobile" />
    <router-view v-else/> -->
    <router-view />
  </div>
</template>

<script>
import HomeMobile from '@/components/HomeMobile.vue';
export default {
  name: 'App',
  components:{
    HomeMobile
  },
  computed:{
    isMobile(){
      return this.$route.path !== '/download_h5' && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFang SC','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue